// extracted by mini-css-extract-plugin
module.exports = {"container":"centeredlogo_container__9Ns62","logo":"centeredlogo_logo__jSB_V","logo__main":"centeredlogo_logo__main__KVDk0"};